import { DISPLAY_MESSAGE, HIDE_MESSAGE } from '../../constants/index';

export const showMessage =
  (bootstrapColor, message, time = 12000) =>
  (dispatch) => {
    dispatch({
      type: DISPLAY_MESSAGE,
      data: {
        type: bootstrapColor,
        message,
      },
    });

    window.setTimeout(() => {
      dispatch({ type: HIDE_MESSAGE });
    }, time);
  };

export default showMessage;
